import { inject, Injectable } from '@angular/core';
import { ServiceResponse } from '@common/data-models/service/service-response';

import { FilterObjectType, FilterSavedState, SectionFiltersPayload } from '../store/inline-filter/inline-filter.models';
import { NomWebServicesJson } from './nom-web-services-json';
import { PersonalSettingsService } from './personal-settings-service';

@Injectable({ providedIn: 'root' })
export class InlineFilterService {
    private nomWebServicesJson = inject(NomWebServicesJson);
    private personalSettingsService = inject(PersonalSettingsService);

    public async saveFilterState(objectType: FilterObjectType, section: string, state: FilterSavedState): Promise<ServiceResponse<boolean>> {
        const helloResults = this.nomWebServicesJson.HelloResults;
        if (!helloResults) {
            return new ServiceResponse<boolean>(false, 'HelloResults not loaded');
        }

        let current: SectionFiltersPayload = {};
        const raw = helloResults.SectionFilters as unknown;
        if (typeof raw === 'string') {
            if (raw.length) {
                try {
                    current = JSON.parse(raw) as SectionFiltersPayload;
                } catch (err) {
                    console.error('[InlineFilter] failed to parse existing SectionFilters', err);
                }
            }
        } else if (raw && typeof raw === 'object') {
            current = structuredClone(raw) as SectionFiltersPayload;
        }

        const bucket = { ...(current[objectType] ?? {}), [section]: state };
        current = { ...current, [objectType]: bucket };

        const stringified = JSON.stringify(current);
        helloResults.SectionFilters = stringified;

        const response = await this.personalSettingsService.updatePersonalSettings({ SectionFilters: stringified });
        if (response.status) {
            localStorage.setItem('GlobalsHelloResults', JSON.stringify(helloResults));
        }
        return response;
    }
}
